export const LATERAL_MENU = '1'
export const USER_MENU = '3'
export const SUITE_MENU = '4'
export const TOP_MENU = '2'
export const APP_THEME= "APP_THEME"

export const ACTION_DELETE_USER="ACTION_DELETE_USER"
export const ACTION_INACTIVATE_USER = "ACTION_INACTIVATE_USER"
